export const PUBLIC_API_SCOPES = [
    'image:generate',
    'video:generate',
    'task:read',
];
//# sourceMappingURL=public-api.js.map